import { Component, Input, OnInit, AfterContentInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { Router, Event, NavigationStart } from '@angular/router';
import { DynamicDialogService } from 'src/app/core/popupmessage/dynamicdialog/dynamicdialog.service';
import { PopupService } from 'src/app/core/popupmessage/popupmessage.service';
// import { LabService } from 'src/app/services/lab.service';
import { MenuTreeItem, NavigationService } from 'src/app/services/nav.service';
import { UserService } from 'src/app/services/user.service';
// import { Lab } from '../labs/lab.class';
import { LoginComponent } from '../login/login.compnent';
// import { UserService } from '../services/user.service';
import {NavGuardService} from './nav.gaurd.service';
import { InputData } from 'src/app/core/popupmessage/dynamicdialog/dynamicdialog.interface';
// import {PopupMesseageService} from '../services/popupMessageService';
// import {SettingsService} from '../services/settings.service';

declare var $:any

@Component({
    selector: 'navigation',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit  {
    @ViewChild('sidenav') sidenav: MatSidenav | undefined;


    options: FormGroup;
    public username:string = "";
    public loggedIn:boolean = false;
    public showMenu:boolean = false;
    // public isAdmin:boolean = false;
    // public isTester:boolean = false;
    public showOption:boolean = false
    public sections={gradations:false, samples:false, specs:false, specGroups:false, aggregateTypes:false, labs:false, plants:false, tax:false,receiving:false, gradationReport:false}
    // public bookmarkInput:InputData = {obj:null,configurationData:[{property:eBookmarkProperties.whiteListAllItems,value:"true"}]}
    public navToTop:boolean = false;
    public actionOptions:{action:string,title:string,disabled:boolean}[]=[]
    public treeMenu:MenuTreeItem[] = [];

    // public labs:Lab[]=[new Lab({id:0,name:"None",samples:[]})];
    // public activeWorkingLab:Lab = this.labs[0];
    // public selectedLab:number = this.labs[0].id;
    public subTitle = "";
    //full app version. wep app version. service version . database version
    public versionNo = "1.1.1A"

    public logoPath = ""
    public footerMsg = "..."
    
    constructor(private router:Router, private navGardService:NavGuardService, private dialogSrv:DynamicDialogService, private userService:UserService, 
                fb: FormBuilder, private navSrv:NavigationService, private popupSrv:PopupService
                ,private titleSrv:Title
        
    ){
        this.options = fb.group({
            bottom: 0,
            fixed: false,
            top: 0,
          });
        router.events.subscribe((event: Event) => {
            if(event instanceof NavigationStart){
                this.isLoggenIn();
                // this.setSubTitle(event);
            }
        });
    }

    ngOnInit(){
        this.isLoggenIn();
        this.loadNavTree();
        this.initSubscriptions();
        const scroller = document.querySelector("#contentContainer");
        if(scroller != null){
            scroller.addEventListener("scroll",event=>{
                this.navToTop = (scroller.scrollTop > 10)
            })
        }
    }

    private initSubscriptions(){
        this.navSrv.setOptions$.subscribe(options=>{
            if(this.navSrv.canUpdateNavOptions()){
                this.showOption = false
                console.log("Options Set")
                console.log(options);
                setTimeout(()=>{
                  this.actionOptions = options;
                  this.showOption = true;
                },0)
            }
        })
        this.navSrv.updateOption$.subscribe(option=>{
            if(this.navSrv.canUpdateNavOptions()){
                for (let index = 0; index < this.actionOptions.length; index++) {
                    if(option.action === this.actionOptions[index].action){
                        this.actionOptions[index].disabled = option.disabled;
                        this.actionOptions[index].title = option.title;
                    }
              }
            }
        })
        this.navSrv.subtTitle$.subscribe(subtTitle=>{
            setTimeout(()=>{
                this.subTitle = subtTitle
            })
            this.titleSrv.setTitle("DeliveryRate:"+subtTitle)
        })
        this.navSrv.newTabLink$.subscribe((link)=>{
            this.openLinkInNewTab(link);
        })
        this.navSrv.footerMsg$.subscribe((msg)=>{
            this.footerMsg = msg;
        })
    }

    public openLogin(){
        this.dialogSrv.show(LoginComponent,undefined,false).subscribe(()=>{
            this.isLoggenIn();
        });
    }

    public logout(){
        // if(!this.navGardService.getPageIsDirty()){
            this.userService.logoutUser();
            this.username = "";
            this.loggedIn = false;
           // this.labService.resetInitLoad();
            // this.isAdmin = false;
            this.showMenu = false;
            // this.isTester = false;
    }

    public isLoggenIn(){
        
        this.username = this.userService.getUserName()
        this.userService.checkStatus().then((data)=>{
            this.loggedIn = true;
            this.loadNavTree();
        }).catch((err)=>{
            this.logout();
        })
    }

    public getNode(nodeName:string):boolean{
        let node = this.userService.getByNodeName(nodeName,"Object")
        if(node !== null && typeof node === "object"){
            return true;
        }else{
            return false;
        }
    }

    public selectedOption(action:string){
        console.log("Selectd Action "+action)
        if(action === "nav.leftsidepanel.show"){
            if(this.sidenav != undefined){
                this.sidenav.open()
            }
        }
        this.navSrv.optionActionClicked({action:action});
    }

    private loadNavTree(){
        this.treeMenu = this.navSrv.getMenuTree();
        console.log(this.treeMenu)
    }

    // public getUserGuide(){
    //     $('#userGuide').foundation('open');

    // }

    // public setFilters(filters:any[]){
    //     if(this.navSrv.canUpdateSideNavFilters()){
    //         this.navSrv.setSideNavFilterValues(filters);
    //     }else{
    //         console.log("updating not permitted");
    //     }
        
    // }

    // public labSelected($event:any){
    //     console.log($event);
    //     // this.labs.forEach((lab,index)=>{
    //     //     if(lab.id === $event){
    //     //         this.activeWorkingLab = lab;
    //     //         this.labService.setWorkingLab(lab);
    //     //     }
    //     // })
    // }

    // private setLabs(){
    //     this.labs = this.labService.getAvaliableLabs();
    //     this.activeWorkingLab = this.labService.getWorkingLab();
    //     this.selectedLab = this.activeWorkingLab.id;
    // }

    public closeSideNav(){
        // console.log("trigging close side nav")
        if(this.sidenav != undefined){
            this.sidenav.close();
        }
        
    }

    public scrollToTop(){
        let ele = document.getElementById("contentContainer")
        if(ele != null){
            ele.scrollTop = 0;
        }
        

    }

    public openLinkInNewTab(link:string){
        let staticUrl :string = 'https://insuranceclaimstest.riverstonegroup.com/'//'http://localhost:4200/'
        var newwindow = window.open(staticUrl+link,"_blank");
    }

    public navigateTo(link:string){
        this.router.navigate([link]);
    }
}